import React from "react"
import { Select } from "antd"
import css from "./ScanHistoryFilter.module.css"

export default function ScanHistoryFilter({ ...props }) {
  const { Option } = Select
  const { options, onFilterChange, placeholder } = props
  return (
    <Select
      onChange={onFilterChange}
      placeholder={placeholder}
      allowClear={true}
      className={css.scanFilter}
      dropdownMatchSelectWidth={false}
    >
      {options.map((option, i) => (
        <Option key={option.value} value={option.value}>
          {option.title}
        </Option>
      ))}
    </Select>
  )
}
